var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_2516_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2516_85",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2516_85",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2516_85",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM+SURBVHgB7Zo/0+lAFMbPe+eWej6Anp6CikZFQUWjUqn4CiqVSkOlodJQaajRU6PXu/fJzDGZfcPuyiYh8psx/mQTeXL2OXs2m5/bf+iL+ENfRiQ47PwlF8xmMxqNRnS9Xsk0iUSC6vU6FYtFMsnPq0lrPB5bYr0kFovRfD4nk7wUYSexq9WKTJLP5z3pOdoetovtdDr0aWgJFsWa9pcfKAsOg1igJDgsYoFUcJjEAumwVCqVpNkSY+ZkMiGTIEsD09lfGmGZWIyVKBA+BeVx2PSVDopo8hB2XE0emFqtRufzmdzgReJzIorwK/gRGVNEEVZBxbN2T6I9sH8X94887BHS0tKrEk9GYKVl2HDtYdGrut52Oo6XRB4WiTz84Rgbh1W8+czjkYc9IvJw2PGslmb88qYqRqaHJsDNwsViQfv9ng6Hw/13XFxctEKhQOl02vrshsA9DKFYdp1Op0qLZ41Gw9Vd0kAFwxbtdvtuj1QqZd3ot0cS0cZrvV7TZrOxfsO2fr//WrRvEnK5nPUyzel0ulWrVevYeN9ut9r74LsugWVpjmwymaThcGhFVQYiirbYh3uH7hpyIIKxXoUT5q6J1YvBYEC9Xs9KXCLoztiGNmjL3RnHgPd18F0wTpIX51gsgCiI3e12v9rzhUAbgH14MR4JTyfKvgtmQZlMRinpQKyTIFgALx7OVPFd8HK5tN6z2ay0Lbq+GHE7GJvBszYigXRpgMQja8ddn7u9CCe64/FIqrytYGRggLEZ3d8JtoTOMs9bTh7sWbzb7ZJJpLU0uhMSA1dcpmBBIpfL5e5zlJDPEhvX3DoVlzTCrVbLdcHuxKNEw78jIcmeJ2HB8XicVJFGGH9q8kEWFAooIBDFR8fFBcYkQQbX1jrn57uHcXKwCSL5KMqyrgxgCS5EVMpSxnfBEFsul63PTkUFtskihn04i6tcHDsvP03rBpxws9m8Tx7sJabKvhAL/75yNyWQYck+AcCJs3gZsADaslgcQ5dAIsyINwBQbqLIQNS5MME2CEWSY8+7uQEQqGAGJSSKDRns/0qlomwBkbcQDDiSmPngMwoQgDEW0UYm5gzvhrcR7BfRk3hh5+sE/wNsAOPM0vRNIgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction);
export default __webpack_public_path__ + "static/media/instruction.34b639835e652c53dd0390f7ead24657.svg";
export { ForwardRef as ReactComponent };